import styled from "styled-components"

interface BadgeProps {
  padding?: number
  paddingX?: number
  paddingY?: number
  radius?: string
  bgColor?: string
  borderColor?: string
  borderStyle?: string
  width?: string
  fontSize?: string
  fontFamily?: string
}

/**
 * Colors passed as props to the component should be respresentation of colors used in theme.js and be included there
 * ex. <Badge bgColor="blue_500" color="white">
 *
 * @namespace
 * @property {string}  bgColor // optional
 * @property {string}  color // optional
 */
const Badge = styled.div<BadgeProps>`
  width: ${({ width, theme }) => (width ? theme.width[width] : "auto")};
  box-sizing: border-box;
  font-family: ${({ theme, fontFamily = "fontBody" }) =>
    `${theme[fontFamily]}, sans-serif`};
  padding: ${({ padding, theme }) => `${theme.spacing[padding || 1]}`};
  ${({ paddingX, theme }) =>
    paddingX &&
    `padding-right: ${theme.spacing[paddingX || 1]};
    padding-left: ${theme.spacing[paddingX || 1]};`}
  ${({ paddingY, theme }) =>
    paddingY &&
    `padding-top: ${theme.spacing[paddingY || 1]};
    padding-bottom: ${theme.spacing[paddingY || 1]};`}
  border-radius: ${({ radius, theme }) => `${theme.radius[radius || "sharp"]}`};
  font-weight: bold;
  line-height: 150%;
  font-size: ${({ fontSize }) => `${fontSize || "12px"}`};
  color: ${({ color, theme }) => (color ? theme[color] : theme["white"])};
  background-color: ${({ bgColor, theme }) =>
    bgColor ? theme[bgColor] : theme["blue_900"]};
  ${({ borderColor, theme, borderStyle }) =>
    borderColor &&
    `border: 1px ${borderStyle ? borderStyle : "solid"} ${
      theme[borderColor] || theme["gray_600"]
    };`}
`

export default Badge
